module.exports = __webpack_public_path__ + "2d0eea443d86c663295f5cae9449f114.svg";